import React, { CSSProperties, forwardRef } from 'react';
import { Input as BaseInput } from '@mui/base';
import clsx from 'clsx';
import './index.css';

export interface CheckboxProps {
  checked?: boolean;
  disabled?: boolean;
  label?: string | JSX.Element;
  indeterminate?: boolean;
  onChange?: (checked: boolean) => void;
  styles?: CSSProperties;
  className?: string;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(props, ref) {
  const { label, onChange, checked, indeterminate = false, disabled = false, className, styles } = props;

  const changeCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    onChange && onChange(isChecked);
  };

  return (
    <div>
      <label style={styles} className={clsx('c-checkbox', disabled && 'c-checkbox--disabled', className)}>
        <BaseInput
          disabled={disabled}
          type="checkbox"
          onChange={changeCheckbox}
          slotProps={{
            input: { ...(checked !== null && { checked }), ref },
          }}
        />
        <span>{label}</span>
        <span className={clsx('c-checkmark', indeterminate && 'undetermined')}></span>
      </label>
    </div>
  );
});

export { Checkbox };
